export const ADD_TO_CART_EVENT = [
  'conversion',
  {
    send_to: 'AW-16526181924/uK1bCLOhiL0ZEKSMpsg9',
    value: 2.0,
    currency: 'USD',
  },
] as const

export const CHECKOUT_EVENT = [
  'coversion',
  {
    send_to: 'AW-16526181924/fSLNCP_EkL0ZEKSMpsg9',
    value: 5.0,
    currency: 'USD',
  },
] as const

export const VIEW_HOME_EVENT = [
  'conversion',
  {
    send_to: 'AW-16526181924/mgi9CJLvir0ZEKSMpsg9',
    value: 1.0,
    currency: 'USD',
  },
] as const

export const SEARCH_EVENT = [
  'conversion',
  {
    send_to: 'AW-16526181924/AiKfCJyliL0ZEKSMpsg9',
    value: 1.0,
    currency: 'USD',
  },
] as const

export const VIEW_PRODUCT_EVENT = [
  'conversion',
  {
    send_to: 'AW-16526181924/S8vjCLjXkL0ZEKSMpsg9',
    value: 1.0,
    currency: 'USD',
  },
] as const

export const PURCHASE_EVENT = [
  'conversion',
  {
    send_to: 'AW-16526181924/wM3-CNfNv9kZEKSMpsg9',
    value: 1.0,
    currency: 'USD',
    transaction_id: '',
  },
] as const
